export enum GalleryOptions_Layout_Type {
  /** COLLAGE - Collage type */
  COLLAGE = 'COLLAGE',
  /** MASONRY - Masonry type */
  MASONRY = 'MASONRY',
  /** GRID - Grid type */
  GRID = 'GRID',
  /** THUMBNAIL - Thumbnail type */
  THUMBNAIL = 'THUMBNAIL',
  /** SLIDER - Slider type */
  SLIDER = 'SLIDER',
  /** SLIDESHOW - Slideshow type */
  SLIDESHOW = 'SLIDESHOW',
  /** PANORAMA - Panorama type */
  PANORAMA = 'PANORAMA',
  /** COLUMN - Column type */
  COLUMN = 'COLUMN',
  /** MAGIC - Magic type */
  MAGIC = 'MAGIC',
  /** FULLSIZE - Fullsize images type */
  FULLSIZE = 'FULLSIZE',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum GalleryOptions_Layout_Orientation {
  /** ROWS - Rows Orientation */
  ROWS = 'ROWS',
  /** COLUMNS - Columns Orientation */
  COLUMNS = 'COLUMNS',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum GalleryOptions_ItemStyle_Crop {
  /** FILL - Crop to fill */
  FILL = 'FILL',
  /** FIT - Crop to fit */
  FIT = 'FIT',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum GalleryOptions_Thumbnails_Alignment {
  /** TOP - Top alignment */
  TOP = 'TOP',
  /** RIGHT - Right alignment */
  RIGHT = 'RIGHT',
  /** BOTTOM - Bottom alignment */
  BOTTOM = 'BOTTOM',
  /** LEFT - Left alignment */
  LEFT = 'LEFT',
  /** NONE - No thumbnail */
  NONE = 'NONE',
  UNRECOGNIZED = 'UNRECOGNIZED',
}